module.exports = __webpack_public_path__ + "img/14.88d707f3.webp";